import React from 'react'

import EditorContent from 'components/RichTextEditor/EditorContent'
import { EditorContextProvider } from 'components/RichTextEditor/EditorContext'
import { ITextProcessor } from 'components/RichTextEditor/processor/constants'
import { IEditorContext } from 'components/RichTextEditor/types'

import { sortSlicesByType } from '../dataFormat/exporter'
import { createParseString } from '../dataFormat/parser'
import MCEditorContext from '../MCEditorContext'
import { useProcessorFabric } from '../shared/hooks/useProcessorFabric'
import Slice from '../slice/Slice'
import { AllowedValues } from '../types'
import { withMCEditorContextProvider } from '../withMCEditorContextProvider'

import cm from './MCTextViewer.module.css'

export interface MCTextViewerProps {
  className?: string
  value?: AllowedValues
}

const MCTextViewer = ({ className, value }: MCTextViewerProps) => {
  const context = React.useContext(MCEditorContext)
  const processor = useProcessorFabric()()
  const { text, slices } = createParseString(context)(value)
  processor.insert(0, text, slices)

  return (
    <div translate="no" className={`${className} ${cm.viewer}`}>
      <EditorContextProvider value={makeEditorContext(processor)}>
        <EditorContent processor={processor} sliceComponent={Slice} sortSlices={sortSlicesByType} />
      </EditorContextProvider>
    </div>
  )
}

export default withMCEditorContextProvider<UnsafeAnyObject, MCTextViewerProps>(MCTextViewer)

const noop = () => {}

const makeEditorContext = (processor: ITextProcessor): IEditorContext => ({
  processor,
  input: null,
  edit: noop,
  undo: noop,
  redo: noop,
  insert: noop,
})
